import { Checkbox, FormControl, FormControlLabel, FormHelperText, Box } from '@mui/material'
import { C1Switch } from 'c1ui'
import { FieldLabel } from 'components/core/dynamic-form/fields/FieldLabel'
import { RenderFieldProps, UnknownField } from 'components/core/dynamic-form/fields/RenderField'
import { FC } from 'react'

export const RenderBoolField: FC<RenderFieldProps> = ({ field, cField, errors, disabled }) => {
    if (field.type.oneofKind !== 'boolField') return <UnknownField field={field} />

    const boolField = field.type.boolField

    switch (boolField.view.oneofKind) {
        case 'checkboxField': {
            const errorMsg = errors[field.name]?.message as string | undefined
            return <Box>
                <FormControl
                    error={!!errorMsg}
                    disabled={disabled}
                >
                    <FormControlLabel
                        control={<Checkbox
                            checked={!!cField.value}
                            value={cField.value}
                            onChange={cField.onChange}
                            onBlur={cField.onBlur}
                        />}
                        name={field.name}
                        label={<FieldLabel name={field.displayName} required={field.required} />}
                    />
                    <FormHelperText error={!!errorMsg}>
                        {errorMsg || field.description}
                    </FormHelperText>
                </FormControl>
            </Box>
        }
        case 'toggleField': {
            const errorMsg = errors[field.name]?.message as string | undefined
            return <Box>
                <FormControl
                    error={!!errorMsg}
                    disabled={disabled}
                >
                    <FormControlLabel
                        control={<C1Switch
                            checked={!!cField.value}
                            onChange={(_, checked): void => cField.onChange(checked)}
                            onBlur={cField.onBlur}
                        />}
                        name={field.name}
                        label={<FieldLabel name={field.displayName} required={field.required} />}
                        labelPlacement="start"
                        sx={{ ml: 0, justifyContent: 'space-between' }}
                    />
                    <FormHelperText error={!!errorMsg}>
                        {errorMsg || field.description}
                    </FormHelperText>
                </FormControl>
            </Box>
        }
        default:
            return <UnknownField field={field} />
    }
}
